import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { catchError, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';

export class ManifestTranslateLoader implements TranslateLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string): Observable<TranslationObject> {
    return this.http.get('/assets/i18n/manifest.json').pipe(
      switchMap((manifest) => {
        const fileName = manifest[lang as keyof typeof manifest];
        if (!fileName) {
          throw new Error(`No translation file found for language: ${lang}`);
        }
        return this.http.get<TranslationObject>(`/assets/i18n/${fileName}`);
      }),
      catchError((_: Error) => {
        return this.http.get<TranslationObject>(`/assets/i18n/${lang}.json`);
      })
    );
  }
}
